import React, { useEffect } from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { aiDrivenSolutionData } from '../data/aiDrivenSolutionData';

const AiDrivenSolutionPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      <Header />
      <div className="container mx-auto px-6 pt-40 pb-20">
        <Fade direction="down" duration={1000}>
          <h1 className="text-5xl font-bold text-center text-gray-800">Innovating with AI-Driven Solutions</h1>
          <p className="text-center text-gray-600 mt-4 max-w-2xl mx-auto">Explore our cutting-edge AI solutions designed to transform businesses and enhance user experiences. From intelligent automation to predictive analytics, we harness the power of AI to drive innovation.</p>
        </Fade>

        <div className="mt-20 space-y-20">
          {aiDrivenSolutionData.map((solution, index) => (
            <Fade key={index} direction={index % 2 === 0 ? 'left' : 'right'} duration={1000}>
              <div className={`flex flex-col md:flex-row items-center gap-10 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}>
                <div className="w-full md:w-1/2 h-80">
                  <img src={solution.image} alt={solution.alt} className="rounded-lg shadow-lg object-cover w-full h-full" />
                </div>
                <div className="w-full md:w-1/2">
                  <h2 className="text-3xl font-bold text-gray-800">{solution.title}</h2>
                  <p className="text-gray-600 mt-4">{solution.description}</p>
                  <Link to={`/ai-solutions/${solution.id}`} className="mt-8 inline-block rounded-lg bg-blue-600 px-8 py-3 text-center text-lg font-semibold text-white no-underline shadow-lg shadow-blue-500/40 transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                    Learn More
                  </Link>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AiDrivenSolutionPage;